import { render, staticRenderFns } from "./ReportTerminals.vue?vue&type=template&id=2fab2164&scoped=true&v-loading=loading&"
import script from "./ReportTerminals.vue?vue&type=script&lang=js&"
export * from "./ReportTerminals.vue?vue&type=script&lang=js&"
import style0 from "./ReportTerminals.vue?vue&type=style&index=0&id=2fab2164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab2164",
  null
  
)

export default component.exports